import {
  CheckCircle,
  BookOpen,
  Clock,
  UserCheck,
  ClipboardList,
  FileText,
  Globe,
  Users,
  User,
  Phone,
  Mail,
  MapPin,
  Briefcase,
} from "lucide-react";
import TopNavbar from "../components/Nav/TopNavbar";
import Footer from "../components/Sections/Footer";
import { useLocation } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { onSubmit } from "../components/Mocks/EmailSender";

// UI Components
function Card({ children, className }) {
  return (
    <div className={`bg-white shadow-md rounded-lg p-4 ${className}`}>
      {children}
    </div>
  );
}

function CardHeader({ children }) {
  return <div className="border-b pb-2 mb-2">{children}</div>;
}

// function CardTitle({ children }) {
//   return <h2 className="text-xl font-bold">{children}</h2>;
// }

function CardContent({ children }) {
  return <div>{children}</div>;
}

function Badge({ children, className }) {
  return (
    <span className={`px-3 py-1 rounded-full text-white text-sm ${className}`}>
      {children}
    </span>
  );
}

// function Button({ children, className, ...props }) {
//   return (
//     <button
//       className={`px-4 py-2 rounded-md font-semibold ${className}`}
//       {...props}
//     >
//       {children}
//     </button>
//   );
// }

export default function TrainingComponent() {
  const location = useLocation();
  const field = location.state;
  const topRef = useRef(null);

  const [isOpen, setIsOpen] = useState(false);
  const [formData, setFormData] = useState({
    nom: "",
    prenom: "",
    tel: "",
    email: "",
    adresse: "",
    raisonSociale: "",
    motivation: "",
    formation: field ? field.title : "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form Data:", formData);
    onSubmit(formData); // Call the function to handle form submission
    // TODO: send to backend
    setIsOpen(false); // Close modal after submission
  };

  useEffect(() => {
    // Scroll to the element with the ref attached
    if (topRef.current) {
      topRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, []);

  if (!field) {
    return (
      <div ref={topRef} className="">
        <TopNavbar />
        <h1 style={{ color: "rgb(255, 153, 0)" }}>VALACADEMY FORMATIONS</h1>

        <div style={{ marginTop: "8%" }}></div>
        <main className="min-h-screen flex flex-col justify-center items-center bg-gradient-to-b from-[#fdfaf5] via-white to-[#fdfaf5] px-6 py-12">
          <h1 className="text-4xl sm:text-5xl font-extrabold  mb-6 text-center max-w-3xl">
            Bienvenue chez{" "}
            <span className="text-orange-600">Valacademy Formations</span> —
            Votre Académie de Formation d'Excellence
          </h1>
          <p className="text-lg text-gray-700 max-w-2xl text-center mb-10 leading-relaxed">
            Chez <strong>Valacademy Formations</strong>, nous proposons une
            large gamme de formations professionnelles adaptées à vos besoins et
            à vos ambitions. Que vous souhaitiez maîtriser les <em>CACES</em>,
            explorer le monde fascinant de l’
            <em>Intelligence Artificielle (IA)</em>, ou développer vos
            compétences en
            <em> Marketing Digital</em>, nos programmes sont conçus pour vous
            guider vers la réussite.
          </p>

          <section className="max-w-4xl w-full">
            <h2 className="text-2xl font-semibold text-orange-500 mb-6 text-center">
              Nos Formations Phares
            </h2>
            <ul className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
              {[
                "CACES – Certificat d’Aptitude à la Conduite En Sécurité",
                "Intelligence Artificielle (IA)",
                "Sauveteur Secouriste du Travail (SST)",
                "Coiffure et Esthétique",
                "Stratégies de Marketing Digital",
                "Design Graphique Personnalisé",
                "Soft Skills - Gestion du Stress - Initiation",
                "Développement Web",
                "Langues Étrangères (Français, Anglais, etc.)",
                "Métiers de la Santé – Kinésithérapie, Infirmier(ère), etc.",
                "Outils Bureautiques (Excel, Word, PowerPoint)",
                "Comptabilité & Paie",
                "Sécurité – Prévention et Intervention",
                "Reconversion Professionnelle – Coaching & Accompagnement",
                "DAO / CAO – Dessin Assisté par Ordinateur",
                "Pharmacie – Préparation et Gestion",
                "Marketing & Commerce International (Chine, Europe...)",
              ].map((formation) => (
                <li
                  key={formation}
                  className="bg-white border border-[#f1eadd] rounded-xl shadow-md p-5 hover:shadow-lg transition-shadow duration-300"
                  aria-label={`Formation ${formation}`}
                >
                  <h3 className="text-lg font-semibold text-orange-600 mb-2">
                    {formation}
                  </h3>
                  <p className="mt-1 text-gray-600 text-sm">
                    Formation conçue pour vous apporter des compétences clés et
                    booster votre carrière professionnelle.
                  </p>
                </li>
              ))}
            </ul>
          </section>
        </main>

        <Footer />
      </div>
    );
  }

  return (
    <div ref={topRef}>
      <div className="max-w-4xl mx-auto p-6">
        <TopNavbar />
        <h1 style={{ color: "rgb(255, 153, 0)" }}>VALACADEMY FORMATIONS</h1>
        <div style={{ marginTop: "8%" }}></div>
        <Card className="shadow-lg rounded-2xl p-6 mt-20">
          <CardHeader>
            <div className="text-3xl font-bold flex items-center gap-2 mb-4">
              <BookOpen size={28} className="text-blue-500" />
              <span>{field.title}</span>
            </div>
          </CardHeader>
          <CardContent>
            <p className="text-gray-600 mb-4 flex items-center gap-2">
              <Globe size={20} className="text-purple-500" />
              <strong>Accessibilité:</strong> {field.accessibility}
            </p>
            <div className="grid md:grid-cols-2 gap-4 mb-6">
              <div className="bg-gray-100 p-4 rounded-lg flex items-center gap-2">
                <Clock size={20} className="text-green-500" />
                <div>
                  <p className="font-semibold">Durée :</p>
                  <p className="text-gray-700">{field.duration}</p>
                </div>
              </div>
              <div className="bg-gray-100 p-4 rounded-lg flex items-center gap-2">
                <UserCheck size={20} className="text-yellow-500" />
                <div>
                  <p className="font-semibold">Prérequis :</p>
                  <p className="text-gray-700">{field.prerequisites}</p>
                </div>
              </div>
            </div>
            <h3 className="text-xl font-semibold mb-3">Objectifs :</h3>
            <ul className="space-y-2 mb-6">
              {field.objectives.map((objective, index) => (
                <li
                  key={index}
                  className="flex items-center gap-2 text-gray-700"
                >
                  <CheckCircle className="text-green-500" size={18} />{" "}
                  {objective}
                </li>
              ))}
            </ul>
            <h3 className="text-xl font-semibold mb-3">Contenu du cours :</h3>
            <div
              className={`grid md:grid-cols-${Math.min(
                4,
                Math.round(field.content.length / 9)
              )} gap-4 mb-6`}
            >
              {field.content.map((item, index) => (
                <p
                  key={index}
                  className="text-gray-700 flex items-center gap-2"
                >
                  <ClipboardList size={18} className="text-blue-500" /> {item}
                </p>
              ))}
            </div>
            <h3 className="text-xl font-semibold mb-3">
              Méthodes pédagogiques :
            </h3>
            <div className="flex flex-wrap gap-2">
              {field.methods.map((method, index) => (
                <Badge key={index} className="bg-blue-500 text-white">
                  {method}
                </Badge>
              ))}
            </div>
            <h3 className="text-xl font-semibold mt-6 mb-3">Évaluation :</h3>
            <ul className="space-y-2 mb-6">
              {field.evaluation.map((evalItem, index) => (
                <li
                  key={index}
                  className="text-gray-700 flex items-center gap-2"
                >
                  <FileText size={18} className="text-red-500" /> {evalItem}
                </li>
              ))}
            </ul>
            <h3 className="text-xl font-semibold mt-6 mb-3">
              Matériel requis :
            </h3>
            <ul className="space-y-2 mb-6">
              {field.materials.map((material, index) => (
                <li
                  key={index}
                  className="text-gray-700 flex items-center gap-2"
                >
                  <Users size={18} className="text-teal-500" /> {material}
                </li>
              ))}
            </ul>
            <p className="text-gray-600 mt-4 flex items-center gap-2">
              <UserCheck size={20} className="text-green-500" />
              <strong>Formateur :</strong> {field.trainer}
            </p>
            <div className="mt-6">
              <button
                onClick={() => setIsOpen(true)}
                className="w-full bg-green-600 hover:bg-green-700 text-white font-semibold py-2 px-4 rounded-lg"
              >
                Je m'inscris
              </button>
            </div>
          </CardContent>
        </Card>
        {isOpen && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div
              style={{ maxHeight: "80vh", marginTop: "5%" }}
              className="overflow-y-auto bg-white rounded-lg shadow-lg max-w-2xl w-full p-6 relative"
            >
              <button
                onClick={() => setIsOpen(false)}
                className="absolute top-2 right-2 text-gray-500 hover:text-red-600 text-xl font-bold"
              >
                &times;
              </button>
              <h2 className="text-xl font-bold mb-4">
                Inscription à la formation
              </h2>
              <form onSubmit={handleSubmit} className="space-y-4">
                <div className="flex space-x-4">
                  <div className="flex-1">
                    <label className="block font-medium flex items-center">
                      <User className="text-blue-600 mr-2" size={20} />
                      Nom
                    </label>
                    <input
                      name="nom"
                      value={formData.nom}
                      onChange={handleChange}
                      className="w-full border border-gray-300 rounded px-3 py-2"
                      required
                    />
                  </div>
                  <div className="flex-1">
                    <label className="block font-medium flex items-center">
                      <User className="text-blue-600 mr-2" size={20} />
                      Prénom
                    </label>
                    <input
                      name="prenom"
                      value={formData.prenom}
                      onChange={handleChange}
                      className="w-full border border-gray-300 rounded px-3 py-2"
                      required
                    />
                  </div>
                </div>

                {/* Telephone and Adresse on the same line */}
                <div className="flex space-x-4">
                  <div className="flex-1">
                    <label className="block font-medium flex items-center">
                      <Phone className="text-red-600 mr-2" size={20} />
                      Téléphone
                    </label>
                    <input
                      type="tel"
                      name="tel"
                      value={formData.tel}
                      onChange={handleChange}
                      className="w-full border border-gray-300 rounded px-3 py-2"
                      required
                    />
                  </div>
                  <div className="flex-1">
                    <label className="block font-medium flex items-center">
                      <MapPin className="text-purple-600 mr-2" size={20} />
                      Adresse
                    </label>
                    <input
                      name="adresse"
                      value={formData.adresse}
                      onChange={handleChange}
                      className="w-full border border-gray-300 rounded px-3 py-2"
                    />
                  </div>
                </div>

                <div>
                  <label className="block font-medium flex items-center">
                    <Mail className="text-orange-600 mr-2" size={20} />
                    Email
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="w-full border border-gray-300 rounded px-3 py-2"
                    required
                  />
                </div>

                <div>
                  <label className="block font-medium flex items-center">
                    <Briefcase className="text-teal-600 mr-2" size={20} />
                    Raison sociale
                  </label>
                  <input
                    name="raisonSociale"
                    value={formData.raisonSociale}
                    onChange={handleChange}
                    className="w-full border border-gray-300 rounded px-3 py-2"
                  />
                </div>

                <div>
                  <label className="block font-medium flex items-center">
                    <FileText className="text-yellow-600 mr-2" size={20} />
                    Motivation ou Objectif
                  </label>
                  <textarea
                    name="motivation"
                    value={formData.motivation}
                    onChange={handleChange}
                    rows={3}
                    className="w-full border border-gray-300 rounded px-3 py-2"
                  />
                </div>

                <div className="flex justify-end">
                  <button
                    type="submit"
                    className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg font-semibold"
                  >
                    Envoyer
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
}
